import { PROVIDER_REGEX, type Providers } from "../types.js";

// Pre-compiled at module load — avoids recompiling on every network request.
const STRING_PATTERNS: Array<[string, Providers]> = [];
const REGEX_PATTERNS: Array<[RegExp, Providers]> = [];

for (const [identifier, provider] of Object.entries(PROVIDER_REGEX)) {
  if (identifier[0] === '/' && identifier[identifier.length - 1] === '/') {
    REGEX_PATTERNS.push([new RegExp(identifier.slice(1, -1)), provider as Providers]);
  } else {
    STRING_PATTERNS.push([identifier, provider as Providers]);
  }
}

export function findEventProvider(endpoint: string): Providers | false {
  for (const [pattern, provider] of STRING_PATTERNS) {
    if (endpoint.includes(pattern)) return provider;
  }
  for (const [regex, provider] of REGEX_PATTERNS) {
    if (regex.test(endpoint)) return provider;
  }
  return false;
}
